import Modal from 'components/Modal';

import styles from './ActivityNotesModal.module.scss';
import {useActivityNotes} from '../../hooks';
import NoteForm from 'components/NoteForm';
import Note from 'components/Note';
import Select from 'components/Select';
import {
  TIMELINE_SORT_OPTIONS,
  TIMELINE_SORT_OPTIONS_LABELS,
} from 'constants/select-options';
import {NoteSort} from 'types';

function ActivityNotesModal({
  isOpen,
  onClose,
  orderId,
}: {
  isOpen: boolean;
  onClose: () => void;
  orderId: string;
}) {
  const {notes, onSubmitNote, timelineSort, setTimelineSort} =
    useActivityNotes(orderId);
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      onRequestClose={onClose}
      className={styles.modal}
    >
      <div className={styles.modalContent}>
        <NoteForm onSubmit={onSubmitNote} isCompleted={false} />
        <div className={styles.sortContainer}>
          <Select
            placeholder="Sort by"
            options={TIMELINE_SORT_OPTIONS}
            styles={{
              control: (base) => ({
                ...base,
                marginTop: 10,
                width: '200px',
              }),
            }}
            value={{
              label: TIMELINE_SORT_OPTIONS_LABELS[timelineSort],
              value: timelineSort,
            }}
            onChange={(value) => setTimelineSort(value?.value as NoteSort)}
          />
        </div>
        <div className={styles.notesWrapper}>
          {notes?.map((note, index) => (
            <Note
              key={note.id}
              {...note}
              text={note.text}
              isCompleted={false}
            />
          ))}
        </div>
      </div>
    </Modal>
  );
}

export default ActivityNotesModal;
